import { deserializeDate } from "@util";
import { Mutable, Properties } from "@util/types";
import PricingRecord, {
	PricingSettings,
	pricingSettingsSchema,
} from "./PricingRecord";
import z from "zod";

export enum CustomerStatus {
	Trial = "trial",
	Active = "active",
	Deactivated = "deactivated",
	Archived = "archived",
}

export default class Customer {
	constructor(props: Properties<Customer>) {
		this.customerId = props.customerId;
		this.customerNo = props.customerNo;
		this.name = props.name;
		this.status = props.status;
		this.legalForm = props.legalForm;
		this.created = props.created;
		this.updated = props.updated;
		this.pricingSettings = props.pricingSettings;
	}

	readonly customerId: string;
	readonly customerNo: number;
	readonly name: string;
	readonly status: CustomerStatus;
	readonly legalForm: string | null;
	readonly created: Date;
	readonly updated: Date;
	readonly pricingSettings: PricingSettings | null;

	private static schema = z.object({
		customerId: z.string(),
		customerNo: z.number(),
		name: z.string(),
		status: z.enum(CustomerStatus),
		legalForm: z.string().nullable(),
		created: z.iso.datetime(),
		updated: z.iso.datetime(),
		pricingSettings: pricingSettingsSchema.nullable(),
	});

	public static fromJson(data: any): Customer {
		const validated = Customer.schema.parse(data);
		return new Customer({
			...validated,
			pricingSettings:
				validated.pricingSettings?.map(PricingRecord.fromJson) ?? null,
			created: deserializeDate.dateTime(data["created"]),
			updated: deserializeDate.dateTime(data["updated"]),
		});
	}
}

export type NewCustomer = Mutable<
	Pick<Customer, "name" | "legalForm" | "status">
>;
export type UpdatedCustomer = Mutable<
	Pick<Customer, "name" | "legalForm" | "pricingSettings">
>;
